import React from 'react';
import { useTranslation } from 'react-i18next';
import { Banner } from '../../ui/Banner/Banner';
import { TranslationKey } from '../../i18n/translationKeys';

/**
 * The walkthrough's terminal screen for a user who cannot accept for the company. No action on
 * purpose — only an administrator can move this forward.
 */
export const AssistantUnavailable: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div
            data-testid="assistant-unavailable"
            className="flex min-h-screen items-center justify-center bg-surface px-xl"
        >
            <div className="w-full max-w-content">
                <Banner
                    tone="info"
                    centered
                    testId="assistant-unavailable-banner"
                    title={t(TranslationKey.Onboarding.Unavailable.Title)}
                >
                    <p>{t(TranslationKey.Onboarding.Unavailable.Body)}</p>
                    <p className="mt-s">{t(TranslationKey.Onboarding.Unavailable.Contact)}</p>
                </Banner>
            </div>
        </div>
    );
};
